import { DataType } from '@/screens/Order/Pages/EditOrder/components/ProductRequirementForm/measurement.column'
import HeaderComponent from '@/screens/SystemConfigure/Components/HeaderComponent/HeaderComponent'
import PopUpMenu from '@/screens/SystemConfigure/Components/PopUpMenu/PopUpMenu'
import ToolbarComponent from '@/screens/SystemConfigure/Components/ToolbarComponent/ToolbarComponent'
import { Space, notification } from 'antd'
import Table, { ColumnsType } from 'antd/lib/table'
import { useState } from 'react'
import { useMutation, useQuery } from 'react-query'
import { deleteDefectList, getDefectList } from '../../DataManagement.transform'
import './DefectList.style.less'
import AddDefectListModal from './AddDefectListModal/AddDefectListModal'
import { Link } from 'react-router-dom'

function DefectList() {
  const [modalDefectList, setModalDefectList] = useState(false)
  const [search, setsearch] = useState('')
  const [page, setPage] = useState(1)

  const [selectedDefectItem, setselectedDefectItem] = useState(null)

  const onEdit = (item) => {
    setselectedDefectItem(item)
    setModalDefectList(true)
  }

  const onAdd = () => {
    setselectedDefectItem(null)
    setModalDefectList(true)
  }

  const deleteMutation = useMutation(async (item: any) => {
    return await deleteDefectList(item)
  })

  const onDelete = async (item: string) => {
    const data = await deleteMutation.mutateAsync(item)
    if (data?.data.statusCode == 400) {
      notification.error({
        duration: 4,
        message: data?.data?.message,
        placement: 'top',
      })
    }
    await refetch()
  }

  const columns: ColumnsType<DataType> = [
    {
      title: 'LIST NAME',
      dataIndex: 'name',
      key: 'name',
      align: 'left',
      render: (_, record: any) => (
        <Link
          className="defect-group-name"
          to={`/system-configure/data-management/defect-list/${record.id}`}
        >
          <p>
            {record?.name}{' '}
            {record?.is_default && (
              <span className="default-text-name">(default)</span>
            )}
          </p>
        </Link>
      ),
    },
    {
      title: 'NO. OF DEFECTS',
      dataIndex: 'name',
      key: 'name',
      align: 'left',
      width: '20%',
      render: (_, record: any) => (
        <p className="defect-group-name">{record?.counter}</p>
      ),
    },
    {
      title: 'ACTION',
      key: 'action',
      render: (_, record: any) => (
        <Space size="middle">
          <PopUpMenu
            onEdit={() => {
              onEdit(record)
            }}
            removeTitle="Deleting this list will removed all associated defect"
            onDelete={() => onDelete(record)}
          />
        </Space>
      ),
      width: '5%',
    },
  ]

  const { data, isLoading, refetch } = useQuery(
    ['defect-list', page, search],
    async () => {
      const payload = {
        page_size: 10,
        page_number: page,
        search,
        status: 'active',
      }
      return await getDefectList(payload)
    }
  )

  return (
    <>
      <HeaderComponent title="Defect Lists" />
      <ToolbarComponent
        onSearch={setsearch}
        onAdd={onAdd}
        buttonText="Add New"
      />
      <Table
        loading={isLoading}
        columns={columns}
        dataSource={data?.data}
        pagination={{
          pageSize: 10,
          current: page,
          onChange: (page) => setPage(page),
          total: data?.pagination?.total_record,
        }}
      />
      {modalDefectList && (
        <AddDefectListModal
          visible={modalDefectList}
          onClose={() => setModalDefectList(false)}
          data={selectedDefectItem}
        />
      )}
    </>
  )
}

export default DefectList
